import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import {
  AppBar,
  Box,
  GlobalStyles,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { Icon } from "../../icons";
import { OssSidebar } from "../components/OssSidebar";
import "./ossWorkspace.css";

const OSS_APP_FONT_STYLES = {
  ".oss-app-font-scope, .oss-app-font-scope *": {
    fontFamily:
      'Pretendard, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif !important',
    letterSpacing: "0 !important",
  },
  ".oss-app-font-scope .MuiTypography-h1, .oss-app-font-scope .MuiTypography-h2, .oss-app-font-scope .MuiTypography-h3, .oss-app-font-scope .MuiTypography-h4, .oss-app-font-scope .MuiTypography-h5, .oss-app-font-scope .MuiTypography-h6": {
    fontWeight: "800 !important",
  },
  ".oss-app-font-scope .MuiButton-root": {
    borderRadius: "8px !important",
    fontWeight: "700 !important",
    boxShadow: "none",
  },
  ".oss-app-font-scope .safe-sidebar-desktop, .oss-app-font-scope .safe-sidebar-mobile, .oss-app-font-scope .safe-sidebar-desktop *, .oss-app-font-scope .safe-sidebar-mobile *, .oss-app-font-scope .ps-menu-label, .oss-app-font-scope .ps-menu-button": {
    fontWeight: "600 !important",
  },
  ".oss-app-font-scope .ps-active, .oss-app-font-scope .ps-active *, .oss-app-font-scope .ps-menu-button.ps-active, .oss-app-font-scope .ps-menu-button.ps-active *": {
    fontWeight: "700 !important",
  },
};

export const OssAppLayout = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const location = useLocation();
  const { group_code, project_code } = useParams();
  const [mobileOpen, setMobileOpen] = useState(false);
  const isDashboardHome = location.pathname === `/oss/${group_code}/${project_code}`;

  return (
    <Box
      className="oss-app-font-scope"
      sx={{
        height: "100dvh",
        overflow: "hidden",
        bgcolor: "#f3f6fa",
        color: "#1f2937",
      }}
    >
      <GlobalStyles styles={OSS_APP_FONT_STYLES} />
      <AppBar
        color="default"
        elevation={2}
        position="sticky"
        sx={(theme) => ({
          zIndex: 1250,
          flexShrink: 0,
          borderBottom: `1px solid ${theme.palette.divider}`,
          borderRadius: 0,
          boxShadow: "none",
          alignItems: "center",
          color: "text.primary",
          justifyContent: "center",
          transition: "border-bottom 0.2s ease-in-out",
          backgroundColor: "rgba(255, 255, 255, 0.88)",
        })}
      >
        <Toolbar
          disableGutters
          sx={{
            width: "100%",
            minHeight: { xs: "64px", md: "64px" },
            paddingInline: { xs: "12px", md: !isDesktop ? "16px" : "30px" },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <Box sx={{ display: "flex", alignItems: "center", minWidth: 0 }}>
              {!isDesktop && (
                <IconButton
                  aria-label="메뉴 열기"
                  onClick={() => setMobileOpen(true)}
                  sx={{ mr: 1 }}
                >
                  <MenuRoundedIcon />
                </IconButton>
              )}
              <Typography
                variant={!isDesktop ? "h6" : "h4"}
                sx={{
                  fontWeight: 800,
                  lineHeight: "24px",
                  opacity: 0.8,
                  marginRight: { xs: 1, md: 2 },
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: { xs: 180, sm: "none" },
                }}
              >
                주문일정관리 시스템
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: { xs: 0.75, sm: 1.25 },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", gap: "6px" }}>
                <IconButton>
                  <Icon name="sunOutlineIcon" style={{ width: "26px", height: "26px", "--stroke-width": "3px" }} />
                </IconButton>
                <IconButton>
                  <Icon name="bellOutlineIcon" style={{ width: "26px", height: "26px", "--stroke-width": "3px" }} />
                </IconButton>
                <IconButton>
                  <Icon name="userIcon" style={{ width: "26px", height: "26px", "--stroke-width": "3px" }} />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      <Box sx={{ display: "flex", height: "calc(100dvh - 64px)", minHeight: 0 }}>
        {isDesktop ? (
          <Box component="aside" sx={{ width: 248, flex: "0 0 248px" }}>
            <OssSidebar />
          </Box>
        ) : (
          <OssSidebar
            isMobile
            toggled={mobileOpen}
            onToggle={() => setMobileOpen(false)}
            onNavigate={() => setMobileOpen(false)}
          />
        )}

        <Box
          component="main"
          className="oss-workspace"
          sx={{
            flex: 1,
            minWidth: 0,
            height: "100%",
            boxSizing: "border-box",
            p: { xs: "12px", md: "20px" },
            overflow: isDesktop && isDashboardHome ? "hidden" : "auto",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};
